import cn from 'clsx'

import { ImageBox } from 'shared-components'

import s from './FeatureImage.module.sass'

function FeatureImage({ post }: any) {
    const { featuredImage } = post

    if (!featuredImage) return null

    return (
        <section className={s.FeatureImage}>
            <div className={cn(s.Cont, 'container')}>
                <ImageBox image={featuredImage} />
            </div>
        </section>
    )
}

export default FeatureImage
